import { render } from "./baseradiogroup.vue?vue&type=template&id=ae46950a&scoped=true"
import script from "./baseradiogroup.vue?vue&type=script&lang=js"
export * from "./baseradiogroup.vue?vue&type=script&lang=js"

import "./baseradiogroup.vue?vue&type=style&index=0&id=ae46950a&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ae46950a"]])

export default __exports__